import { useGoogleAnalytics } from '~/pages/layout/hooks/useGoogleAnalytics';
import { useGoogleAnalyticsUserProperties } from '~/pages/layout/hooks/useGoogleAnalyticsUserProperties';

/**
 * Runs GA init and user-property sync in one component so effects run in
 * declaration order (init before set user_properties). Must sit inside
 * AuthProvider + QueryClientProvider.
 */
export function GoogleAnalyticsSync({ enabled }: { enabled: boolean }) {
  useGoogleAnalytics({ enabled });
  useGoogleAnalyticsUserProperties({ enabled });
  return null;
}
